import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import StripSiteSearchQueryParameters from './StripSiteSearchQueryParameters';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedStripSiteSearchQueryParameters = connect(
  mapStateToProps, null,
)(StripSiteSearchQueryParameters);

export default withTranslation(['administration'])(ConnectedStripSiteSearchQueryParameters as any);
